import { axios } from "lib/axios";
import { useQuery } from "react-query";

export const getContactDetails = () => {
  return axios.get(`/pages/slug/contact-us`);
};

export const useContactDetails = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["contactDetails"],
    queryFn: () => getContactDetails(),
  });
};
